(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      this.header &&
        document.documentElement.style.setProperty(
          '--header-height',
          `${this.header.offsetHeight}px`
        );
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal && this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function initNutreskaShopChips(container) {
  const root = (container || document).querySelector('.nutreska-mega--shop');
  if (!root) return;

  const chips = root.querySelectorAll('[data-benefit-chip]');
  const panels = root.querySelectorAll('[data-benefit-panel]');
  const dropdown = root.querySelector('.nutreska-mega__benefit-panels');
  const shell = root.querySelector('.nutreska-mega__chips-shell') || root;
  let hideTimer;

  if (!chips.length || !panels.length || !dropdown || !shell) return;

  const activate = (id) => {
    chips.forEach((chip) => {
      chip.classList.toggle(
        'nutreska-mega__chip--active',
        chip.dataset.benefitChip === id
      );
    });

    panels.forEach((panel) => {
      panel.hidden = panel.dataset.benefitPanel !== id;
    });
  };

  const positionDropdownUnder = (chip) => {
    const shellRect = shell.getBoundingClientRect();
    const chipRect = chip.getBoundingClientRect();
    const centerX = chipRect.left - shellRect.left + chipRect.width / 2;

    dropdown.style.left = `${centerX}px`;
    dropdown.style.transform = 'translateX(-50%)'; // center under that chip
  };

  const showDropdown = (chip) => {
    clearTimeout(hideTimer);
    dropdown.classList.add('nutreska-mega__benefit-panels--visible');

    const targetChip =
      chip ||
      root.querySelector('.nutreska-mega__chip--active') ||
      chips[0];

    if (!targetChip) return;

    positionDropdownUnder(targetChip);

    const id = targetChip.dataset.benefitChip;
    if (id) activate(id);
  };

  const hideDropdown = () => {
    hideTimer = setTimeout(() => {
      dropdown.classList.remove('nutreska-mega__benefit-panels--visible');
      chips.forEach((chip) =>
        chip.classList.remove('nutreska-mega__chip--active')
      );
    }, 160); // small delay so you can move into the dropdown
  };

  // Hovering a chip: show a narrow dropdown directly under THAT chip
  chips.forEach((chip) => {
    chip.addEventListener('mouseenter', () => {
      showDropdown(chip);
    });

    chip.addEventListener('focus', () => {
      showDropdown(chip);
    });
  });

  // Leaving the whole chip row / dropdown hides it
  shell.addEventListener('mouseleave', hideDropdown);

  // Keep open while hovering the dropdown itself
  dropdown.addEventListener('mouseenter', () => {
    clearTimeout(hideTimer);
  });
  dropdown.addEventListener('mouseleave', hideDropdown);

}
  function initHoverMegaMenus(context) {
    const root = context || document;
    const detailsList = root.querySelectorAll(
      '.header__inline-menu .mega-menu[data-hover-open="true"]'
    );

    detailsList.forEach((details) => {
      // prevent double-binding if section reloads
      if (details._hoverBound) return;
      details._hoverBound = true;

      const summary = details.querySelector('summary');
      const content = details.querySelector('.mega-menu__content');
      let hideTimer;

      const clearHide = () => {
        if (hideTimer) {
          clearTimeout(hideTimer);
          hideTimer = null;
        }
      };

           const openMenu = () => {
        clearHide();

        // Close any other hover mega menus so only one is ever open
        detailsList.forEach((other) => {
          if (other !== details) {
            other.removeAttribute('open');
          }
        });

        details.setAttribute('open', '');
      };


      const scheduleClose = () => {
        clearHide();
        hideTimer = setTimeout(() => {
          details.removeAttribute('open');
        }, 2000); // stays open at least 2s after mouse leaves
      };

      // Keep it open while hovering trigger or dropdown
      [summary, content, details].forEach((el) => {
        if (!el) return;
        el.addEventListener('mouseenter', openMenu);
        el.addEventListener('mouseleave', scheduleClose);
      });
    });
  }




   document.addEventListener('DOMContentLoaded', function () {
    initNutreskaShopChips();
    initHoverMegaMenus();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.nutreska-mega--shop')) {
      initNutreskaShopChips(event.target);
    }
    if (event.target.querySelector('.header__inline-menu')) {
      initHoverMegaMenus(event.target);
    }
  });


  } catch(e) { console.error(e); }
})();
})();
